import styled, { css } from 'styled-components'
import respondTo from '../../theme/respondTo'

import heroMobileBackground from '../../assets/images/hero-home-page-background-mobile.png'
import heroDesktopBackground from '../../assets/images/hero-home-page-background-desktop.png'

import { HEADER_HEIGHT } from 'components/Header/Header'

export const SContainer = styled.section`
  ${({ theme }) => css`
    background-color: ${theme.colors.backgroundBlack};
    background-image: url(${heroMobileBackground});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: right 0;

    padding: calc(86px + ${HEADER_HEIGHT}) ${theme.space.lg}px 60px;
    margin-top: -${HEADER_HEIGHT};

    ${respondTo.lg`
      background-image: url(${heroDesktopBackground});
      padding: calc(128px + ${HEADER_HEIGHT}) ${theme.space.lg}px ${
      theme.space.lg - 4
    }px;
    `}

    .content {
      max-width: 1240px;
      margin: 0 auto;
    }

    .heading {
      font-size: 1.75rem;
      line-height: 2.2rem;
      font-weight: ${theme.weight.bold};
      color: white;
      text-align: center;

      ${respondTo.lg`
        text-align: left;
        font-size: 3.25rem;
        line-height: 4.125rem;
      `}

      span {
        color: ${theme.colors.lightPink};
        text-shadow: 1px 1px 0 ${theme.colors.azure};

        ${respondTo.lg`
          text-shadow: 2px 2px 0 ${theme.colors.azure};
        `}
      }
    }

    .subheading {
      color: ${theme.colors.lightGray2};
      font-size: 1.125rem;
      line-height: 1.56rem;
      text-align: center;
      margin: ${theme.space.md + 4}px auto ${theme.space.xxl - 4}px;
      max-width: 259px;

      ${respondTo.lg`
         text-align: left;
         font-size: 1.375rem;
         line-height: 1.875rem;
         margin: ${theme.space.md + 4}px auto ${theme.space.xl + 8}px;
         max-width: 100%;
      `}
    }

    .cta {
      color: ${theme.colors.white};
      font-weight: 500;
      line-height: 1.375rem;
      margin-bottom: ${theme.space.md}px;

      ${respondTo.lg`
        font-size: 1.25rem;
        line-height: 1.75rem;
        margin-bottom: ${theme.space.md + 4}px;
      `}
    }

    .buttons-wrapper {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      margin: 0 auto 76px;

      & > a {
        margin-top: ${theme.space.lg}px;

        &:first-of-type {
          margin-top: 0;
        }
      }

      ${respondTo.lg`
        flex-direction: row;
        margin: 0 0 108px;
        max-width: 600px;
  
        & > a {
          margin-top: ${theme.space.lg}px;
          flex: 1;
        }
        
        & > a:nth-of-type(2) {
          margin-right: ${theme.space.xl + 4}px;
        }
        
        & > a:first-of-type {
          margin-top: 0;
          width: 100%;
          flex: auto;
        }
      `}

      a {
        i {
          padding-top: ${theme.space.xs}px;
          margin-left: ${theme.space.sm}px;
        }

        &.disable-link {
          background-color: ${theme.colors.white};
          cursor: not-allowed;
          color: ${theme.colors.disabledLink};
          pointer-events: none;

          &:hover {
            background-color: ${theme.colors.white};
            color: ${theme.colors.disabledLink};
          }
        }
      }
    }

    .divider-horizontal {
      border: none;
      background-color: ${theme.colors.lightGray};
      width: 80px;
      height: 1px;
      margin: ${theme.space.xl + 8}px auto ${theme.space.md}px 0;

      ${respondTo.lg`
        margin: 116px auto ${theme.space.md + 4}px 0;
      `}
    }

    .socials {
      display: flex;
      margin-top: ${theme.space.md + 4}px;

      & > a {
        margin-right: ${theme.space.md}px;
      }

      &-text {
        color: ${theme.colors.white};
        line-height: 1.375rem;
        font-weight: 500;

        ${respondTo.lg`
          font-size: 1.25rem;
          line-height: 2rem;
        `};
      }
    }
  `}
`
